// extracted by mini-css-extract-plugin
export default {"container":"workTgSelector_container__ziBol","title":"workTgSelector_title__H5I7i","errorText":"workTgSelector_errorText__3TkCp"};